import React from "react"
import { ImgRowContainer, ImageWrapper } from "./style"
import AvenueImg from "components/AvenueImg"

const ImgRow = ({ images }) => {
  const {
    srcset1,
    sourceurl1,
    srcset2,
    sourceurl2,
    srcset3,
    sourceurl3,
    count,
    width,
    height
  } = images
  

  return (
    <ImgRowContainer>
      <ImageWrapper>

    {height/width}
        <AvenueImg
          fluid={{
            sourceUrl: sourceurl1,
            srcSet: srcset1,
            mediaDetails: {
              width,
              height
            },
            sizes: "(max-width: 1024px) 100vw, 550px",
          }}
        />
      </ImageWrapper>

      <ImageWrapper>
        <AvenueImg
          fluid={{
            sourceUrl: sourceurl2,
            srcSet: srcset2,
            mediaDetails: {
              width,
              height
            },
            sizes: "(max-width: 1024px) 100vw, 550px",
          }}
        />
      </ImageWrapper>

      {count == 3 && (
        <ImageWrapper>
          <AvenueImg
            fluid={{
              sourceUrl: sourceurl3,
              srcSet: srcset3,
              mediaDetails: {
              width,
              height
            },
              sizes: "(max-width: 1024px) 100vw, 550px",
            }}
          />
        </ImageWrapper>
      )}
    </ImgRowContainer>
  )
}

export default ImgRow
